<template>
	<div class="p-grid">
		<div class="p-col-12 p-pt-1 p-pb-1 p-mt-3">


          <div class="search-bar" style="float: right">
            <i class="pi pi-search" />
            <InputText v-model="filters['global'].value" :placeholder="$t('analytics.search')" :aria-label="$t('analytics.search')"/>
            <i class="pi pi-times" @click="function() {filters['global'].value=null}"/>
          </div>
          <div class="p-formgroup-inline p-ai-center">
            <div class="p-field">
              <Dropdown id="modelNumber" v-model="filters['modelNumber'].value" :options="modelNumbers" optionLabel="name" optionValue="code"
                :placeholder="$t('analytics.filter_model_ph')" />
            </div>
            <div v-if="!role.includes('SERVICE')" class="p-field">
              <Dropdown id="labName" v-model="filters['labName'].value" :options="laboratories" optionLabel="name" optionValue="code"
                :placeholder="$t('analytics.filter_lab_ph')" />
            </div>
            <div class="p-field">
              <ToggleButton v-model="statusButton" :onLabel="$t('analytics.filter_online')" :offLabel="$t('admin.appliances.filter_online')"  :aria-label="$t('common.online')+'/'+$t('common.offline')" />      
            </div>
          </div>

          <DataTable :value="appliances" stripedRows 
            v-model:filters="filters" responsiveLayout="stack" dataKey="serialNumber" 
            breakpoint="960px" selectionMode="single" @row-click="openAnalytics" :rowClass="rowClass">
            <template #empty>
                {{$t('analytics.empty_list')}}
            </template>
            <template #loading>
                {{$t('analytics.loading_list')}}
            </template>

            <Column field="serialNumber" :header="$t('analytics.col_serialnumber')" ></Column>

            <Column field="modelNumber" :header="$t('analytics.col_model')" >
              <template #body="slotProps">
                <div>
                  {{$functions.fixModelName(slotProps.data.modelNumber)}} 
                  <img v-if="slotProps.data.online" src="assets/irinox/icons/status_online_small.svg" class="p-pl-1"  :alt="$t('common.online')"/>
                  <img v-else src="assets/irinox/icons/status_offline_small.svg" class="p-pl-1"  :alt="$t('common.offline')"/>
                </div>
              </template>
            </Column>

            <Column field="name" :header="$t('analytics.col_name')" >
              <template #body="slotProps">
                <div>
                  {{slotProps.data.name ?? slotProps.data.modelNumber}}
                </div>
              </template>
            </Column>

            <Column v-if="!role.includes('SERVICE')" field="labName" :header="$t('analytics.col_lab')" ></Column>

          </DataTable>


    </div>
	</div>

  <!--        -->
  <!-- ERRORS -->
  <!--        -->
  <IrinoxDialogDark :visible="dialog.error" 
    mode="error" 
    :message="$t('analytics.error_dialog')"
    :life="3000" 
    @update:visible="dialog.error = $event" />
  <IrinoxDialogDark :visible="dialog.blockingError" 
    mode="error" 
    :message="$t('analytics.error_dialog')"
    :life="0" 
    @update:visible="dialog.blockingError = $event" />

</template>

<script>
import ApplianceService from '../../service/ApplianceService';
import IrinoxDialogDark from '../IrinoxDialogDark.vue';
// import IrinoxDialogLight from '../IrinoxDialogLight.vue';
import {FilterMatchMode} from 'primevue/api';
import { mapGetters } from 'vuex';

export default {
    components: {
          IrinoxDialogDark,
          // IrinoxDialogLight
    },
    data() {
        return {
          filters: {
              'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
              'modelNumber': {value: null, matchMode: FilterMatchMode.EQUALS},
              'labName': {value: null, matchMode: FilterMatchMode.EQUALS},
              'online': {value: null, matchMode: FilterMatchMode.EQUALS}
          },
          serialNumber: null,
          modelNumbers: [{ 
              code: null,
              name: this.$t('admin.appliances.filter_remove') 
            }],
          laboratories: [{ 
              code: null,
              name: this.$t('admin.appliances.filter_remove') 
            }],
          statusButton: false,
          dialog: {
            error: false,
            blockingError: false
          }
        };
    },
    computed: {
        ...mapGetters({
          personaltoken: 'userdata/personaltoken',
          appliances: 'appliances/appliances',
          role: 'userdata/role',
        }),
    },
    watch: {
      statusButton: 'statusButtonToggle'
    },
    created() {
      this.$store.commit('appliances/appliances', []);
      this.applianceService = new ApplianceService();
    },
    mounted() {
      this.reloadAppliances();
    },
    methods: {
      reloadAppliances() {
        this.applianceService.getAppliances(this.personaltoken)
          .then((appliances) => {
            this.$store.commit('appliances/appliances', appliances);
            let mns = [];
            let ls = [];
            for(let i=0; i<appliances.length; i++) {
              mns.push({ code: appliances[i].modelNumber, name: this.$functions.fixModelName(appliances[i].modelNumber) });
              if(this.appliances[i].labName) {
                ls.push({ code: appliances[i].labName, name: appliances[i].labName });
              }
            }
            this.modelNumbers = this.$functions.uniqByKeepFirst(mns, item => item.code).sort((a,b) => this.$functions.compareStrings(a,b,'name'));
            this.modelNumbers.unshift({ 
              code: null,
              name: this.$t('admin.appliances.filter_remove') 
            });
            this.laboratories = this.$functions.uniqByKeepFirst(ls, item => item.code).sort((a,b) => this.$functions.compareStrings(a,b,'name'));
            this.laboratories.unshift({ 
              code: null,
              name: this.$t('admin.appliances.filter_remove') 
            })
          })
          .catch(error => {
            console.error("ERROR "+error);
            this.$store.commit('appliances/appliances', []);
            this.dialog.blockingError = true;
          });
      },
      statusButtonToggle() {
        if(this.statusButton) {
          this.filters['online'].value = true;
        } else {
          this.filters['online'].value = null;
        }
      },
      openAnalytics(event) {
        if(event.data.gamma !== 'EF Next') {
          this.$router.push({ name: 'appliance-analytics', params: { serialNumber: event.data.serialNumber }});
        }
      },
      rowClass(data) {
        return [{ 'disabled': data.gamma === 'EF Next' }];
      },
    }

}
</script>

<style scoped>

.irinox-form .p-dropdown {
  width: 200px;
}

.irinox-form .search-bar input {
  width: 100px;
}


</style>